export default {
  mode: 'history',
  routes: [
    {
      path: '/force-login',
      name: 'ForceLogin',
      props: (route) => ({ code: route.query.code }),
      component: () => import('@Views/ForceLogin'),
    },
    {
      path: '/callback.html',
      name: 'Callback',
      component: () => import('@Views/Callback'),
    },
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: 'home' */ '@Views/Home'),
    },
    {
      path: '/lexicon',
      name: 'lexicon',
      component: () => import(/* webpackChunkName: 'lexicon' */ '@Views/LexiconPage.vue'),
      children: [
        {
          path: 'anatomie',
          name: 'anatomie',
          component: () => import(/* webpackChunkName: 'lexicon' */ '@Components/Lexicon/anatomie.vue'),
        },
        {
          path: 'astigmatisme',
          name: 'astigmatisme',
          component: () => import(/* webpackChunkName: 'lexicon' */ '@Components/Lexicon/astigmatisme.vue'),
        },
      ],
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import('@Views/Error'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@Views/Login'),
      meta: {
        allowUnauthenticatedAccess: true,
      },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import(/* webpackChunkName: 'settings' */ '@Views/Settings'),
    },
    {
      path: '/products',
      name: 'Products',
      component: () => import(/* webpackChunkName: 'products' */ '@Views/DiscoverOurProducts'),
    },
    {
      path: '/relate/:step',
      name: 'Relate',
      component: () => import(/* webpackChunkName: 'quizz' */ '@Views/Relate'),
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@Views/Logout'),
    },
    {
      path: '/Understand',
      name: 'Understand',
      component: () => import(/* webpackChunkName: 'understand' */ '@Views/UnderstandPage'),
    },
    {
      path: '/player',
      component: () => import(/* webpackChunkName: 'understand' */ '@Views/DemoStoreLoader'),
      children: [
        {
          path: '/',
          name: 'frameUnderstand',
          component: () => import(/* webpackChunkName: 'understand' */ '@Views/FrameVideo'),
          children: [
            {
              path: ':category/:nameVideo',
              name: 'videoUnderstand',
              meta: {
                id: 'nameVideo',
              },
              component: () => import(/* webpackChunkName: 'understand' */ '@Components/Demos/Video/DemoVideo.vue'),
            },
            {
              path: 'product/:youtubeId/:title',
              name: 'videoProduct',
              meta: {
                id: 'youtubeId',
              },
              component: () => import(/* webpackChunkName: 'understand' */ '@Components/Demos/Video/DemoVideo.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/demos',
      name: 'StoreLoader',
      component: () => import(/* webpackChunkName: 'configurator' */ '@Views/DemoStoreLoader'),
      children: [
        {
          path: 'configurator/:correct?/:protect?/:optimize?',
          name: 'Configurator',
          component: () => import(/* webpackChunkName: 'configurator' */ '@Views/ConfiguratorPage'),
        },
        {
          path: ':id',
          name: 'Demo',
          component: () => import(/* webpackChunkName: 'demos' */ '@Views/Demos/Frame'),

          children: [
            {
              path: '360/:idSituation',
              name: '360',
              meta: {
                id: '360',
              },
              // component: () => import("@Components/Demos/360/360")
              component: () => import(/* webpackChunkName: '360' */ '@Components/Demos/360/360Babylon'),
            },
            {
              path: 'video/:idSituation',
              name: 'video',
              meta: {
                id: 'video',
              },

              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Video/DemoVideo.vue'),
            },
            {
              path: 'videoSlider/:idSituation',
              name: 'videoSlider/:idSituation',
              meta: {
                id: 'videoSlider',
              },
              component: () =>
                import(/* webpackChunkName: 'demos' */ '@Components/Demos/Slider/SliderVideoLuminosity.vue'),
            },
            {
              path: 'videoBlur/:idSituation',
              name: 'videoBlur/:idSituation',
              meta: {
                id: 'videoBlur/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Slider/SliderVideoBlur'),
            },
            {
              path: 'photo/:idSituation',
              name: 'photo/:idSituation',
              meta: {
                id: 'photo/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Photo/DemoPhoto.vue'),
            },
            {
              path: 'specific/:idSituation',
              name: 'specific/:idSituation',
              meta: {
                id: 'specific/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Photo/DemoSpecific.vue'),
            },
            {
              path: 'photoCompareMode/:idSituation',
              name: 'photoCompareMode/:idSituation',
              meta: {
                id: 'photoCompareMode/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Photo/PhotoCompareMode.vue'),
            },
            {
              path: 'videoCompare/:idSituation',
              name: 'videoCompare/:idSituation',
              meta: {
                id: 'videoCompare/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Video/DemoVideo.vue'),
            },
            {
              path: 'compareSlider/:idSituation',
              name: 'compareSlider/:idSituation',
              meta: {
                id: 'compareSlider/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Photo/CompareSlider.vue'),
            },
            {
              path: 'compareSliderSingle/:idSituation',
              name: 'compareSliderSingle/:idSituation',
              meta: {
                id: 'compareSliderSingle/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'demos' */ '@Components/Demos/Photo/CompareSlider.vue'),
            },
            {
              path: 'compareStairs/:idSituation',
              name: 'compareStairs/:idSituation',
              meta: {
                id: 'compareStairs/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Stairs/StairsCompare.vue'),
            },
            {
              path: 'transitions/:idSituation',
              name: 'transitions/:idSituation',
              meta: {
                id: 'transitions/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/Transitions.vue'),
            },
            {
              path: 'diaporama/:idSituation',
              name: 'diaporama/:idSituation',
              meta: {
                id: 'diaporama/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Diaporama.vue'),
            },
            {
              path: 'propositions/:idSituation',
              name: 'propositions/:idSituation',
              meta: {
                id: 'propositions/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/PropositionsMenu.vue'),
            },
            {
              path: 'propositions/montures/:idSituation',
              name: 'propositions/montures/:idSituation',
              meta: {
                id: 'propositions/montures/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Propositions.vue'),
            },
            {
              path: 'propositions/verres/:idSituation',
              name: 'propositions/verres/:idSituation',
              meta: {
                id: 'propositions/verres/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Propositions.vue'),
            },
            {
              path: 'propositions/personalisation/:idSituation',
              name: 'propositions/personalisation/:idSituation',
              meta: {
                id: 'propositions/personalisation/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Propositions.vue'),
            },
            {
              path: 'propositions/verres/recommandations/:idSituation/:idRecommandation',
              name: 'propositions/verres/recommandations/:idSituation/:idRecommandation',
              meta: {
                id: 'propositions/verres/recommandations/:idSituation/:idRecommandation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Recommandations.vue'),
            },
            {
              path: 'propositions/montures/recommandations/:idSituation/:idRecommandation',
              name: 'propositions/montures/recommandations/:idSituation/:idRecommandation',
              meta: {
                id: 'propositions/montures/recommandations/:idSituation/:idRecommandation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Recommandations.vue'),
            },
            {
              path: 'immersia/:idSituation',
              name: 'immersia/:idSituation',
              meta: {
                id: 'immersia/:idSituation',
              },
              component: () => import(/* webpackChunkName: 'pixi' */ '@Components/Demos/Photo/Diaporama.vue'),
            },
            {
              path: 'xperio/:idSituation',
              name: 'xperio/:idSituation',
              meta: {
                id: 'xperio/:idSituation',
              },
              component: () => import('@Components/Demos/Video/Xperio.vue'),
            },
            {
              path: 'sunny/:idSituation',
              name: 'sunny/:idSituation',
              meta: {
                id: 'sunny/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/Sun.vue'),
            },
            {
              path: 'xperio_est/:idSituation',
              name: 'xperio_est/:idSituation',
              meta: {
                id: 'xperio_est/:idSituation',
              },
              component: () => import('@Components/Demos/Photo/Xperio_est.vue'),
            },
            {
              path: '*',
              name: 'Situation404',
              component: () => import('@Views/Error404'),
            },
          ],
        },
        {
          path: '*',
          name: 'Demo404',
          component: () => import('@Views/Error404'),
        }
      ],
    },
    {
      path: '*',
      name: 'Error404',
      component: () => import('@Views/Error404'),
    },
  ],
};
